export default {
    uah: '₴',
    validate: {
        Login: {
            email: {
                required: 'Введіть електронну адресу',
                email: 'Некоректна почта'
            },
            password: {
                required: 'Введіть пароль',
                minLength: 'Мінімальна довжина паролю - 6 символів'
            }
        },
        Register: {
            email: {
                required: 'Введіть електронну адресу',
                email: 'Некоректна електронна адреса'
            },
            password: {
                required: 'Введіть пароль',
                minLength: 'Мінімальна довжина паролю - 6 символів'
            },
            confirmPassword: {
                required: 'Підтвердіть пароль',
                equal: 'Паролі не співпадають'
            },
            firstName: {
                required: 'Введіть ім\'я'
            },
            lastName: {
                required: 'Введіть прізвище'
            }
        },
        Businesses: {
            businessId: {
                numeric: 'Некоректний номер бізнеса'
            },
            refillSum: {
                required: 'Введіть сумму',
                numeric: 'Некорректна сумма'
            },
            fee: {
                numeric: 'Некоректний відсоток'
            },
            limits: {
                clientLimit: {
                    max: 'Перевищено встановлений ліміт'
                }
            }
        },
        UnallocatedClients: {
            fee: {
                numeric: 'Некоректний відсоток'
            }
        },
        Leaders: {
            leaderId: {
                numeric: 'Некоректний номер лідера'
            },
            refillSum: {
                required: 'Введіть суму',
                numeric: 'Некоректна сума'
            },
            fee: {
                numeric: 'Некоректний відсоток'
            },
            limits: {
                accountLimit: {
                    max: 'Максимальна кількість аккаунтів - 10.000'
                },
                clientBase: {
                    max: 'Максимальна кількість клієнтів - 1.000.000'
                }
            }
        },
        AdminEditor: {
            phoneNumber: {
                required: 'Введіть номер телефону',
                length: 'Некоректний номер телефону'
            },
            taxId: {
                required: 'Введіть ІПН',
                length: 'Довжина ІПН - 10 символів'
            },
            cardNumber: {
                required: 'Введіть номер картки',
                length: 'Номер картки некоректний'
            },
            firstName: {
                required: 'Введіть ім\'я'
            },
            lastName: {
                required: 'Введіть прізвище'
            },
            email: {
                required: 'Введіть електронну адресу',
                email: 'Некоректна електронна адреса'
            },
            passportNumber: {
                required: 'Введіть номер паспорту'
            }
        },
        RoleEditor: {
            name: {
                required: 'Введіть назву ролі'
            }
        },
        Cards: {
            clientId: {
                numeric: 'Некоректний номер клієнта'
            },
            paymentId: {
                numeric: 'Некоректний номер платежу'
            },
            phoneNumber: {
                length: 'Некоректний номер телефону'
            }
        },
        News: {
            header: {
                required: 'Введіть заголовок'
            },
            publicationDate: {
                required: 'Оберіть дату публікації'
            },
            publicationTime: {
                required: 'Оберіть час публікації'
            },
            text: {
                required: 'Введіть текст публікації',
                maxLength: 'Текст повинен включати менш ніж 400 симоволів'
            },
            imageSize: {
                minValue: 'Занадто великий розмір файлу'
            }
        },
        BalanceHistory: {
            clientId: {
                numeric: 'Некоректний номер клієнта'
            },
            paymentId: {
                numeric: 'Некоректний номер платежу'
            },
            taxiOrderId: {
                numeric: 'Некоректний номер замовлення таксі'
            },
            phoneNumber: {
                required: 'Введіть номер телефону',
                length: 'Некоректний номер телефону'
            },
            amount: {
                required: 'Введіть сумму',
                numeric: 'Некоректна сумма'
            },
            comment: {
                length: 'Довжина перевищує 255 символів'
            }
        },
        Referral: {
            clientId: {
                numeric: 'Некоректний номер клієнта'
            }
        },
        Payments: {
            orderId: {
                numeric: 'Некоректний номер замовлення'
            },
            clientId: {
                numeric: 'Некоректний номер клієнта'
            },
            phoneNumber: {
                numeric: 'Некоректний номер телефону'
            },
            taxiOrderId: {
                numeric: 'Некоректний номер замовлення таксі'
            }
        },
        Notification: {
            title: {
                required: 'Введіть заголовок'
            },
            body: {
                maxLength: 'Надто довгий текст'
            },
            phoneFilters: {
                maxLength: 'Надто довгий текст'
            }
        },
        PromotionalLeader: {
            numberOfFunds: {
                required: 'Введіть кількіть коштів',
                decimal: 'Некоректна кількіть коштів',
                isEnoughMoney: 'Недостатньо коштів'
            },
            amount: {
                required: 'Введіть кількість бізнесів'
            },
            accountId: {
                required: 'Оберіть лідера'
            },
            date: {
                required: 'Введіть дату'
            }
        },
        PromotionalBusiness: {
            date: {
                required: 'Введіть дату'
            },
            accountId: {
                required: 'Оберіть бізнеса'
            },
            amount: {
                required: 'Введіть кількість  клієнтів'
            }
        },
        PurchasePromotional: {
            money: {
                required: 'Введіть суму',
                decimal: 'Сума некоректна',
                isEnoughMoney: 'Недостатньо коштів'
            }
        },
        CreateAccount: {
            activeLeader: {
                required: 'Введіть лідера'
            },
            roleId: {
                required: 'Введіть роль'
            }
        },
        Payouts: {
            withdraw: {
                availablePrice: 'На Вашому рахунку недостатньо коштів',
                decimal: 'Некоректна сума',
                multipleOf: 'Сума має бути кратна 100'
            }
        },
        Settings: {
            password: {
                required: 'Введіть пароль',
                minLength: 'Мінімальна довжина паролю - 6 символів'
            },
            newPassword: {
                required: 'Введіть новий пароль',
                minLength: 'Мінімальна довжина паролю - 6 символів'
            },
            confirmNewPassword: {
                required: 'Підтвердіть новий пароль',
                equal: 'Паролі не співпадають'
            },
            phoneNumber: {
                required: 'Введіть номер телефону',
                length: 'Некоректний номер телефону'
            },
            passportNumber: {
                required: 'Введіть номер паспорту'
            },
            taxId: {
                required: 'Введіть ІПН',
                length: 'Довжина ІПН - 10 символів'
            },
            cardNumber: {
                required: 'Введіть номер картки',
                length: 'Номер картки некоректний'
            },
            firstName: {
                required: 'Введіть ім\'я'
            },
            lastName: {
                required: 'Введіть прізвище'
            }
        },
        ExtendedReports: {
            Editor: {
                name: {
                    required: 'Введіть назву звіту'
                },
                sqlQuery: {
                    required: 'Сформуйте SQL-запит'
                }
            },
            Categories: {
                name: {
                    required: 'Введіть назву категорії'
                }
            }
        },
        other: {
            numeric: 'Некоректне значення'
        },
        Groups: {
            name: {
                required: 'Введіть назву'
            },
            phones: {
                required: 'Введіть телефони'
            },
            brand: {
                required: 'Оберіть бренд'
            },
            subGroups: {
                numeric: 'Некоректне значення',
                max: 'Перевищено максимум',
                min: 'Нижче мінімума'
            },
            count: {
                required: 'Введіть кількість поїздок',
                numeric: 'Некоректне значення',
                max: 'Перевищено максимум',
                min: 'Некоректне значення'
            },
            fromDate: {
                required: 'Оберіть дату',
                max: 'Некоректне значення'
            },
            toDate: {
                required: 'Оберіть дату',
                max: 'Перевищено максимум'
            }
        },
        CashbackEditor: {
            name: {
                required: 'Введіть назву'
            },
            groupId: {
                required: 'Оберіть групу'
            },
            fromDate: {
                required: 'Оберіть дату'
            },
            toDate: {
                required: 'Оберіть дату'
            }
        }
    },
    locales: {
        en: 'English',
        ru: 'Русский',
        uk: 'Українська'
    },
    menu: {
        addClientArticle: 'Створити новину',
        articleList: 'Список новин',
        clientNews: 'Клієнтські новини',
        login: 'Вхід',
        register: 'Зареєструватися',
        dashboard: 'Інформаційна панель',
        edit: 'Редагувати',
        clientArticleEditor: 'Редактор новини',
        admin: 'Aдміністратор',
        admins: 'Адміністратори',
        customerEditor: 'Редагування клієнта',
        adminEditor: 'Редагування адміністратора',
        rolesManaging: 'Керування ролями',
        roles: 'Список ролей',
        permissions: 'Список дозволів',
        createRole: 'Створити нову роль',
        user: 'Користувач',
        payments: 'Платежі',
        yourBusinesses: 'Ваші бізнесмени',
        paymentLog: 'Журнал платежу',
        referral: 'Реферали',
        customersBase: 'Клієнтська база',
        business: 'Бізнеси',
        card: 'Картки',
        news: 'Новини',
        customers: 'Клієнти',
        balanceHistory: 'Історія баланса',
        notification: 'Push-сповіщення',
        createAccount: 'Створити акаунт',
        leaders: 'Лідери',
        accountBalanceHistory: 'Фінанси',
        clientRefillHistory: 'Історія поповнень балансу клієнтів',
        leaderReferralCodes: 'Коди для запрошення клієнтів',
        businessReferralCodes: 'Коди для запрошення бізнесів',
        referralCodes: 'Реферальні коди',
        payouts: 'Виплати',
        payoutsLogs: 'Історія заявки',
        reports: 'Звіти',
        leaderReport: 'Звіти',
        businessReport: 'Звіти',
        systemNotifications: 'Сповіщення',
        systemLogs: 'Активність',
        systemLogsSettings: 'Налаштування активності',
        settings: 'Налаштування',
        leaderGroup: 'По лідерах',
        businessGroup: 'По бізнесам',
        dayGroup: 'Виведення коштів',
        reportLeaderGroup: 'Звіт по лідерах',
        reportBusinessGroup: 'Звіт по бізнесам',
        reportDayGroup: 'Звіт з виведення коштів',
        extendedReports: 'Розширені звіти',
        extendedReportsList: 'Список розширених звітів',
        extendedReportsCategories: 'Список категорій звітів',
        promotionalAccount: 'Рекламний рахунок',
        bonusSystems: 'Бонусні системи',
        groups: 'Групи клієнтів',
        cashbackSystems: 'Кешбек та бонуси',
        cashbackEditor: 'Редагування бонусної системи',
        cashbackCreator: 'Створення бонусної системи',
        unallocatedClients: 'Нерозподілені клієнти',
        moderation: 'Модерація',
        undefined: ''
    },
    pages: {
        ClientNewsEditor: {
            articleData: 'Дані новини'
        },
        AddClientArticle: {
            sendTo: {
                all: 'Всі',
                allTaxi: 'Всі (таксі)',
                allDelivery: 'Всі (доставка)',
                selected: 'Обрані номери'
            }
        },
        ClientNews: {
            table: {
                id: 'Номер новини',
                createdAt: 'Створена',
                sendTo: 'Кому відправлена',
                status: 'Статус',
                header: 'Назва',
                text: 'Текст новини',
                actions: 'Дії'
            },
            status: {
                shown: 'Опублікована',
                hide: 'Прихована'
            },
            sendTo: {
                all: 'Всім',
                allTaxi: 'Клієнтам таксі',
                allDelivery: 'Клієнтам доставки',
                selected: 'Обраним номерам'
            },
            delete: 'Видалити',
            cancel: 'Скасувати',
            deleteTitle: 'Видалити новину?',
            cannotBeUndone: 'Ця дія незворотна'
        },
        Login: {
            title: 'Вхід у систему',
            submit: 'Увійти',
            form: {
                email: 'Електронна адреса',
                password: 'Пароль'
            },
            forgotPassword: 'Забули пароль?',
            rememberMe: 'Запам\'ятати мене',
            socialTitle: 'Або увійдіть за допомогою',
            emailText: 'Ми відправили інструкції по відновленню паролю на <strong>:email</strong> (перевірте папки «Вхідні» та «Спам»).',
            forgotPasswordTitle: 'Інструкції відправлені',
            emailSubject: 'Забули пароль? Відновіть його!',
            forgotText: 'Вітаємо! Ви відправили запит на відновлення пароля від Вашої електронної адреси. Для того, щоб задати новий пароль, перейдіть за посиланням'
        },
        Register: {
            title: 'Реєстрація у системі',
            submit: 'Зареєструватись',
            form: {
                email: 'Електронна адреса',
                firstName: 'Ім\'я',
                lastName: 'Прізвище',
                password: 'Пароль',
                confirmPassword: 'Підтвердіть пароль',
                role: 'Роль',
                includeTelephony: 'Враховувати офлайн замовлення'
            }
        },
        Dashboard: {
            overviewBalance: 'Ваш баланс',
            overviewPercent: 'Відсоток',
            overviewClients: 'Ваші клієнти',
            overviewBusinesses: 'Ваші бізнесмени',
            overviewFee: 'Онлайн відсоток',
            overviewTelephonyFee: 'Офлайн відсоток',
            clientBase: 'База клієнтів',
            accountLimit: 'Ліміт аккаунтів',
            clientLimit: 'Ліміт клієнтів',
            promoBalance: 'Ручний рекламний баланс',
            autoPromoBalance: 'Автоматичний рекламний баланс',
            referralTitle: 'Графік залучених партнерів',
            balanceTitle: 'Графік Вашого заробітку',
            noDataReferrals: 'Поки що Ви нікого не залучили',
            noDataBalance: 'Поки що Ви нічого не заробили',
            noOrders: 'Ваші клієнти не здійснили жодної поїздки',
            ordersAnalytics: 'Аналітика замовлень',
            ordersTitle: 'Історія Ваших замовлень',
            ordersIncomeTitle: 'Доходи з замовлень',
            table: {
                balance: 'Баланс',
                clients: 'Клієнти',
                online: 'Онлайн замовлення',
                offline: 'Телефонія',
                deliveryOrders: 'Замовлення доставки'
            },
            dateMenu: {
                month: 'Місяць',
                week: 'Тиждень',
                day: 'День'
            }
        },
        UnallocatedClients: {
            cards: {
                workedServerCount: 'Кількість серверів',
                all: 'Кількість клієнтів',
                unallocated: 'Нерозподілені клієнти',
                allocated: 'Розподілені клієнти'
            },
            table: {
                id: 'Номер',
                name: 'Назва',
                enabled: 'Aктивний',
                apiUrl: 'API url',
                apiKey: 'API ключ',
                balance: 'Баланс',
                fee: 'Відсоток',
                createdAt: 'Створено',
                city: 'Місто',
                actions: ''
            },
            enabled: {
                true: 'Так',
                false: 'Ні'
            },
            editFeeText: 'Натисніть Enter щоб зберегти',
            reset: {
                title: 'Підтвердіть дію',
                text: 'Ви впевнені, що хоче обнулити баланс данного серверу?',
                actions: {
                    agree: 'Підтвердити',
                    disagree: 'Скасувати'
                }
            }
        },
        ReferralCodes: {
            editText: 'Натисніть Enter щоб зберегти',
            table: {
                name: 'Назва',
                code: 'Код',
                actions: ''
            }
        },
        RefRegister: {
            title: 'Ласкаво просимо в Sprut',
            invalidCode: 'Невірний реферальний код',
            confirmation: 'Введіть код, відправлений на',
            registered: 'Вітаємо! Ви стали клієнтом SPRUT',
            buttons: {
                appStore: 'Завантажуй в <br> <b>App Store</b>',
                googlePlay: 'Завантажуй в <br> <b>Google Play</b>'
            }
        },
        Payments: {
            autocomplete: {
                type: 'Виберіть тип платежу',
                status: 'Виберіть статус платежу',
                cardBinding: 'Додавання картки (1₴)',
                orderPayment: 'Платіж за поїздку',
                rechargeBalance: 'Поповнення балансу',
                new: 'Новий',
                deliveryPayment: 'Платіж за доставку',
                success: 'Успішно',
                error: 'Помилка',
                sandbox: 'Sandbox'
            },
            table: {
                clientId: 'Номер клієнта',
                phoneNumber: 'Номер телефону',
                taxiOrderId: 'Номер замовлення',
                orderId: 'Номер транзакції',
                amount: 'Сума',
                status: 'Статус',
                type: 'Тип',
                createdAt: 'Створено',
                updatedAt: 'Оновлено',
                actions: ''
            },
            link: 'До журналу платежу',
            clientId: 'Номер клієнта',
            phoneNumber: 'Номер телефону',
            taxiOrderId: 'Номер замовлення',
            orderId: 'Номер транзакції'
        },
        PaymentLogs: {
            table: {
                request: 'Запит',
                response: 'Відповідь',
                type: 'Тип',
                createdAt: 'Створено',
                updatedAt: 'Оновлено'
            }
        },
        Referrals: {
            tableTitle: 'Ваші клієнти',
            autocomplete: {
                noData: 'Дані відсутні'
            },
            table: {
                clientId: 'Номер клієнта',
                createdAt: 'Дата реєстрації',
                paymentType: 'Тип оплати за замовчуванням',
                balance: 'Баланс',
                card: 'Картка',
                cash: 'Готівка',
                referralCode: 'Реферальний код',
                referralCodeName: 'Назва реферального коду',
                businessEmail: 'Запросив клієнта',
                leaderEmail: 'Електронна адреса лідера'
            },
            clientId: 'Номер клієнта',
            businessShareText: 'Викликати таксі за 3 секунди? Зі Sprut можливо все! Завантажуй мобільний додаток за посиланням: ',
            leaderShareText: 'Вітаємо! Розпочни свій бізнес в таксі вже зараз! Реєструйся за посиланням: '
        },
        Admins: {
            email: 'Email',
            role: 'Назва ролі',
            phone: 'Номер телефону',
            table: {
                id: 'Номер адміністратора',
                email: 'Електронна адреса',
                createdAt: 'Створено',
                firstName: 'Ім\'я',
                lastName: 'Прізвище',
                cardNumber: 'Номер карти',
                appVersion: 'Версія додатку',
                taxId: 'Ідентифікаційний код',
                phoneNumber: 'Номер телефону',
                role: 'Роль користувача',
                actions: 'Дії'
            }
        },
        AdminEditor: {
            adminInfo: 'Інформація про адміністратора',
            firstName: 'Ім\'я',
            lastName: 'Прізвище',
            customerInfo: 'Інформація про користувача',
            email: 'Електронна адреса',
            phoneNumber: 'Номер телефону',
            cardNumber: 'Номер картки',
            taxId: 'Ідентифікаційний код',
            passportNumber: 'Номер паспорту',
            roleInfo: 'Інформація про роль',
            role: 'Роль'
        },
        Roles: {
            name: 'Назва ролі',
            table: {
                name: 'Назва ролі',
                adminsCount: 'Кількість користувачів',
                state: 'Стан',
                actions: 'Дії',
                active: 'Активна',
                disabled: 'Не активна'
            },
            permissionsSettings: {
                name: 'Назва дозволу',
                activation: 'Активація'
            },
            permissionsList: {
                'watch-payments': 'Перегляд історії платежів',
                'send-push-notifications': 'Відправка Push-сповіщень',
                'watch-balance-history': 'Перегляд історії балансу',
                'refill-client-balance': 'Поповнення балансу клієнтів',
                'watch-cards': 'Перегляд карт користувачів',
                'watch-leaders': 'Перегляд списку лідерів',
                'watch-business': 'Перегляд списку бізнесів',
                'create-account': 'Створення акаунтів',
                'watch-referrals': 'Перегляд списку рефералів',
                'create-news': 'Робота з публікаціями',
                'watch-account-balance-history': 'Перегляд історії балансу акаунту',
                'edit-withdraws': 'Робота з виплатами',
                'watch-reports': 'Перегляд звітів',
                'edit-admins': 'Перегляд списку адміністраторів',
                'edit-roles': 'Робота зі списком ролей',
                'change-admin-permissions': 'Доступ до списку всіх дозволів',
                'watch-extended-reports': 'Перегляд розширених звітів',
                'edit-extended-reports': 'Редагування розширених звітів',
                'watch-client-refill-history': 'Історія поповнень балансу клієнтів',
                'watch-system-logs': 'Доступ до активності',
                'watch-client-groups': 'Перегляд груп клієнтів',
                'watch-cashback-system': 'Перегляд систем кешбека',
                'watch-unallocated-clients': 'Перегляд нерозподілених клієнтів',
                'lock-account': 'Блокування акаунтів'
            }
        },
        RoleEditor: {
            name: 'Назва ролі',
            edit: 'Редагування ролі',
            create: 'Нова роль',
            available: 'Доступні',
            chosen: 'Обрані',
            established: 'Встановлені',
            permissionsList: 'Список дозволів для ролі',
            reportCategoriesList: 'Категорії звітів',
            active: 'Активна',
            disabled: 'Не активна',
            emptyList: 'Список дозволів порожній'
        },
        Businesses: {
            tableTitleConfirmed: 'Список залучених бізнесів - {0}',
            tableTitleUnconfirmed: 'Очікують підтвердження електронної адреси - {0}',
            adminTitle: 'Список бізнесів',
            adminUnconfirmedTitle: 'Очікують підтвердження електронної адреси',
            businessId: 'Введіть номер бізнесмена',
            query: 'Введіть запит',
            table: {
                businessId: 'Номер бізнеса',
                email: 'Електронна адреса',
                createdAt: 'Створено',
                firstName: 'Ім\'я',
                lastName: 'Прізвище',
                phoneNumber: 'Номер телефону',
                referrerEmail: 'Електронна адреса лідера',
                balance: 'Баланс',
                refillBalance: 'Поповнити баланс',
                refillPromoBalance: 'Поповнити рекламний рахунок',
                fee: 'Онлайн відсоток',
                telephonyFee: 'Офлайн відсоток',
                leaderFee: 'Онлайн % від лідера',
                leaderTelephonyFee: 'Офлайн % від лідера',
                clientLimit: 'Ліміт клієнтів',
                limitedTo: 'Обмежений до',
                processedAfterRestrictions: 'Оброблений після обмежень',
                unlimitedRights: 'Необмежені права',
                purchased: 'Акаунт куплено',
                businesses: 'Бізнеси',
                clients: 'Реферали',
                autoPromoBalance: 'Автоматичний рекламний баланс',
                actions: 'Дії',
                lock: 'Заблокувати акаунт',
                unlock: 'Розблокувати акаунт',
                settings: 'Налаштування обмежень',
                amountToPay: 'Вартість облікового запису',
                amountPaid: 'Виплачена сума'
            },
            limits: {
                title: 'Зміна обмежень',
                available: 'Всього доступно: {0}',
                used: 'Використано'
            },
            refillSum: 'Введіть сумму поповнення',
            lockDialog: {
                title: 'Заблокувати бізнеса',
                message: 'Акаунт даного бізнеса буде заблоковано і він не зможе користуватись системою'
            }
        },
        Cards: {
            table: {
                id: 'ID',
                clientId: 'Номер клієнта',
                phoneNumber: 'Номер телефону клієнта',
                paymentId: 'Номер платежу',
                cardMask: 'Маска карти',
                cardToken: 'Токен карти',
                default: 'За замовчуванням',
                errorCount: 'Лічильник помилок',
                createdAt: 'Створено',
                updatedAt: 'Оновлено'
            },
            clientId: 'Номер клієнта',
            paymentId: 'Номер платежу',
            phoneNumber: 'Номер телефону клієнта',
            true: 'Так',
            false: 'Ні'
        },
        News: {
            selects: {
                all: 'Всім',
                leader: 'Лідерам',
                business: 'Бізнесам'
            },
            count: 'Кількість новин',
            header: 'Інформація для партнерів',
            showTo: 'Показати',
            showText: 'Публікація',
            latePublication: 'Відкладена публікація',
            publicationDate: 'Дата публікації',
            publicationTime: 'Час публікації',
            text: 'Текст публікації',
            image: 'Оберіть зображення',
            share: 'Оберіть реферальний код, щоб поділитись',
            noCode: 'У вас немає жодного реферального коду. Створіть його перед тим як поділитись',
            edit: 'Редагування публікації',
            create: 'Нова публікація',
            shareImageBlock: {
                code: {
                    size: 'Розмір коду(px)',
                    position: 'Позиція',
                    positions: {
                        'top-left': 'Зверху зліва',
                        'top-right': 'Зверху справа',
                        'bottom-left': 'Знизу зліва',
                        'bottom-right': 'Знизу справа'
                    }
                },
                addQRCode: 'Додати QR код'
            }
        },
        balanceHistories: {
            table: {
                id: 'ID',
                clientId: 'Номер клієнта',
                phoneNumber: 'Номер телефону клієнта',
                taxiOrderId: 'Номер замовлення',
                paymentId: 'Номер платежу',
                change: 'Зміни',
                balance: 'Баланс',
                cashbackSystemId: 'Номер бонусної системи',
                paymentType: 'Тип платежу',
                comment: 'Коментар',
                createdAt: 'Створено',
                orderType: 'Тип замовлення',
                updatedAt: 'Оновлено',
                refilledBy: 'Поповнено(ким)',
                system: 'Система',
                success: 'Успішно'
            },
            refillDialog: {
                title: 'Поповнити баланс клієнту',
                phoneNumber: 'Номер телефону',
                sum: 'Сума поповнення',
                comment: 'Коментар'
            },
            clientId: 'Номер клієнта',
            taxiOrderId: 'Номер замовлення',
            paymentId: 'Номер платежу',
            paymentType: 'Тип платежу',
            paymentTypes: {
                refill: 'Поповнення',
                trip: 'Поїздка',
                delivery: 'Доставка',
                taxi: 'Таксі',
                cashback: 'Кешбек'
            },
            phoneNumber: 'Номер телефону клієнта'
        },
        Notification: {
            count: 'Кількість повідомлень',
            clients: 'Готові до відправлення',
            filters: {
                selectAll: 'Обрати всіх клієнтів',
                phones: 'Телефони',
                success: 'Успішно',
                duplicate: 'Дублікати',
                notFound: 'Не знайдено',
                withoutToken: 'Без токена',
                validationError: 'Помилка валідації'
            },
            message: {
                title: 'Заголовок *',
                body: 'Текст',
                image: 'Посилання на зображення'
            },
            result: {
                title: 'Результат',
                androidSuccess: 'Android успішно',
                androidFailure: 'Android не успішно',
                iosSuccess: 'iOS успішно',
                iosFailure: 'iOS не успішно'
            },
            error: {
                invalidToken: 'Не вірний токен пристрою',
                emptyToken: 'Токен пристрою не надіслано',
                requiredData: 'Поле з тілом запиту не надіслано',
                couldNotParsed: 'Неможливо прочитати тіло запиту',
                InvalidRegistration: 'Недійсна реєстрація',
                NotRegistered: 'Не зареєстровано',
                InvalidPackageName: 'Недійсна назва пакета',
                MismatchSenderId: 'Невідповідність ідентифікатора відправника',
                InvalidParameters: 'Недійсні параметри',
                MessageTooBig: 'Повідомлення занадто велике',
                InvalidDataKey: 'Недійсний ключ даних',
                Unavailable: 'Недоступно',
                InternalServerError: 'Внутрішня помилка сервера',
                DeviceMessageRateExceeded: 'Перевищена швидкість повідомлення на пристрої',
                BadCollapseId: 'Неправильний ідентифікатор',
                BadDeviceToken: 'Неправильний маркер пристрою',
                BadExpirationDate: 'Неправильний термін придатності',
                BadMessageId: 'Неправильний ідентифікатор повідомлення',
                BadPriority: 'Неправильний пріоритет',
                BadTopic: 'Неправильна тема',
                DeviceTokenNotForTopic: 'Токен пристрою не належить даній темі',
                DuplicateHeaders: 'Дублікати заголовків',
                IdleTimeout: 'Час очікування не працює',
                MissingDeviceToken: 'Відсутній маркер пристрою',
                MissingTopic: 'Відсутня тема',
                PayloadEmpty: 'Корисне навантаження порожнє',
                TopicDisallowed: 'Тема заборонена',
                BadCertificate: 'Неправильний сертифікат',
                BadCertificateEnvironment: 'Неправильне середовище сертифікатів',
                ExpiredProviderToken: 'Термін дії провайдера минув',
                Forbidden: 'Заборонено',
                InvalidProviderToken: 'Недійсний маркер постачальника',
                MissingProviderToken: 'Відсутній маркер постачальника',
                BadPath: 'Поганий шлях',
                MethodNotAllowed: 'Метод заборонений',
                Unregistered: 'Незареєстрований',
                PayloadTooLarge: 'Корисне навантаження занадто велике',
                TooManyProviderTokenUpdates: 'Занадто багато оновлень маркера постачальника',
                TooManyRequests: 'Занадто багато запитів',
                ServiceUnavailable: 'Послуга недоступна',
                Shutdown: 'Закрито'
            }
        },
        Leaders: {
            or: 'або',
            id: 'Введіть номер лідера',
            query: 'Введіть запит',
            table: {
                id: 'Номер лідера',
                email: 'Електронна адреса',
                createdAt: 'Створено',
                firstName: 'Ім\'я',
                lastName: 'Прізвище',
                phoneNumber: 'Номер телефону',
                balance: 'Баланс',
                refillBalance: 'Поповнити баланс',
                refillPromoBalance: 'Поповнити рекламний рахунок',
                fee: 'Онлайн відсоток',
                telephonyFee: 'Офлайн відсоток',
                clientBase: 'База клієнтів',
                accountLimit: 'Ліміт аккаунтів',
                limitedTo: 'Обмежений до',
                processedAfterRestrictions: 'Оброблений після обмежень',
                unlimitedRights: 'Необмежені права',
                purchased: 'Акаунт куплено',
                clients: 'Реферали',
                businesses: 'Бізнеси',
                distributedClients: 'Розподілені клієнти',
                promoBalance: 'РРБ',
                autoPromoBalance: 'АРБ',
                actions: 'Дії',
                enableTelephony: 'Увімкнути офлайн замовлення',
                disableTelephony: 'Вимкнути офлайн замовлення',
                lock: 'Заблокувати акаунт',
                unlock: 'Розблокувати акаунт',
                settings: 'Налаштування обмежень',
                amountToPay: 'Вартість облікового запису',
                amountPaid: 'Виплачена сума'
            },
            limits: {
                title: 'Зміна обмежень'
            },
            refillSum: 'Введіть суму поповнення',
            lockDialog: {
                title: 'Заблокувати лідера',
                message: 'Акаунт даного лідера буде заблоковано і він не зможе користуватись системою'
            }
        },
        CreateAccounts: {
            selects: {
                admin: 'Адмін',
                leader: 'Лідер',
                business: 'Бізнес'
            }
        },
        Settings: {
            form: {
                password: 'Пароль',
                newPassword: 'Новий пароль',
                confirmNewPassword: 'Підтвердіть новий пароль'
            },
            tabs: {
                details: 'Особисті дані',
                settings: 'Налаштування входу'
            },
            labels: {
                firstName: 'Ім\'я',
                lastName: 'Прізвище',
                email: 'Електронна адреса',
                phoneNumber: 'Номер телефону',
                cardNumber: 'Номер картки',
                taxId: 'Ідентифікаційний код',
                passportNumber: 'Номер паспорта',
                role: 'Інформація про роль'
            },
            personalInfo: 'Персональна інформація',
            additionalInfo: 'Додаткова інформація',
            connectAccount: 'Підключити акаунт',
            changePass: 'Зміна пароля',
            fbAccount: 'Facebook акаунт',
            googleAccount: 'Google акаунт',
            confirmation: {
                title: 'Збереження персональних данних',
                description: 'Якщо Ви підтвердите збереження, Ваш обліковий запис буде тимчасово заблокований, а дані будуть передані адміністрації на розгляд.'
            },
            agreedWith: 'Згоден(-на) з',
            termsOfUsage: 'умовами використання'
        },
        BusinessRegister: {
            title: 'Підтвердіть свою електронну адресу!',
            description: 'Ваш акаунт було успішно зареєстровано. Для завершення процесу, будь ласка, перевірте Вашу електронну адресу',
            emailSubject: 'Ви успішно зареєструвались! Залишилось тільки підтвердити адресу!',
            registerText: 'Ми раді бачити Вас в нашій команді SPRUT. Залишився останній крок! Перейдіть за посиланням, щоб підтвердити реєстрацію Вашого акаунту'
        },
        AccountBalanceHistory: {
            currentAccountBalance: 'Ваш поточний баланс (₴)',
            table: {
                partner: 'Партнер',
                clientId: 'Номер клієнта',
                taxiOrderId: 'Номер замовлення таксі',
                phoneNumber: 'Номер телефону',
                change: 'Надходження',
                balance: 'Баланс',
                cashbackSystemId: 'Номер кешбек системи',
                bonusBalance: 'Показати рекламний рахунок',
                type: 'Тип надходження',
                email: 'Електронна адреса',
                statuses: {
                    trip: 'Поїздка',
                    refill: 'Поповнення',
                    delivery: 'Доставка'
                },
                createdAt: 'Створено'
            }
        },
        clientRefillHistory: {
            table: {
                date: 'Дата',
                change: 'Сума поповнення',
                balance: 'Баланс',
                phoneNumber: 'Номер телефону',
                refilledBy: 'Поповнено(ким)',
                comment: 'Коментар'
            }
        },
        Payouts: {
            table: {
                sum: 'Сума',
                balance: 'Баланс',
                accountId: 'Номер користувача',
                type: 'Тип',
                email: 'Електронна адреса',
                firstName: 'Ім\'я',
                lastName: 'Прізвище',
                phoneNumber: 'Номер телефону',
                status: 'Статус',
                cardNumber: 'Номер картки',
                comment: 'Коментар',
                updatedAt: 'Оновлено',
                createdAt: 'Дата заявки'
            },
            statuses: {
                new: 'Новий',
                processing: 'В обробці',
                success: 'Завершений',
                cancelled: 'Скасований'
            },
            filters: {
                status: 'Виберіть статус',
                query: 'Введіть запит'
            },
            payoutDescription: 'Ви можете залишити заявку на виведення зароблених коштів. Середній час очікування - 3 банківських дні. Заявка може бути відхилена у разі виявлення шахрайських дій на акаунті.',
            payoutDialogTitle: 'Ви впевнені, що хочете вивести ',
            onBalance: 'На Вашому балансі',
            withdraw: 'Виведення коштів',
            withdrawAll: 'Зняти все',
            sum: 'Сума в гривнях',
            hrn: 'грн'
        },
        Reports: {
            sum: 'Сума',
            table: {
                date: 'Дата',
                invitedClients: 'Запрошені клієнти',
                totalTrips: 'Кількість поїздок',
                earnedMoney: 'Зароблено коштів'
            },
            leader: {
                table: {
                    business: 'Бізнес',
                    invitedClients: 'Запрошені клієнти',
                    totalTrips: 'Кількість поїздок',
                    earnedMoney: 'Зароблено коштів лідером',
                    earnedReferralsMoney: 'Зароблено коштів бізнесом'
                }
            },
            admin: {
                table: {
                    business: 'Бізнес',
                    leader: 'Лідер',
                    invitedBusinesses: 'Запрошені бізнеси',
                    invitedClients: 'Запрошені клієнти',
                    totalTrips: 'Кількість поїздок',
                    earnedLeaderMoney: 'Зароблено коштів лідером',
                    earnedBusinessMoney: 'Зароблено коштів бізнесом',
                    earnedBusinessesMoney: 'Зароблено коштів бізнесами',
                    date: 'Дата',
                    totalBalance: 'Коштів на балансах',
                    requested: 'Запитів на виведення',
                    success: 'Виведено'
                }
            }
        },
        ExtendedReports: {
            List: {
                table: {
                    '#': '#',
                    name: 'Назва',
                    category: 'Категорія',
                    sqlQuery: 'SQL-запит',
                    created: 'Створено',
                    updated: 'Оновлено',
                    actions: 'Дії',
                    forLeader: 'Для лідера'
                },
                filters: {
                    sqlQuery: 'SQL-запит'
                }
            },
            Editor: {
                create: 'Новий звіт',
                edit: 'Редагування звіту',
                remove: 'Ви дійсно хочете видалити даний звіт ?',
                name: 'Назва',
                category: 'Категорія',
                sqlQuery: 'SQL-запит',
                meta: 'SQL-метадані',
                useDate: 'Фільтр по датам',
                useTime: 'Фільтр по часу',
                useQuery: 'Текстовий запит',
                forLeader: 'Для лідера'
            },
            Reports: {
                category: 'Категорія',
                report: 'Звіт',
                filtration: 'Фільтрація',
                another: 'Інше',
                filters: {
                    startDate: 'Початкова дата',
                    endDate: 'Кінцева дата',
                    startTime: 'Час початку',
                    endTime: 'Час закінчення',
                    query: 'Текстовий запит'
                }
            },
            Categories: {
                name: 'Назва',
                list: 'Список категорій звітів',
                action: 'Дії',
                remove: 'Ви дійсно хочете видалити цю категорію ?',
                edit: 'Редагування категорії',
                create: 'Нова категорія'
            }
        },
        PayoutLog: {
            table: {
                id: 'ID',
                status: 'Статус',
                updatedAt: 'Оновлено',
                createdAt: 'Створено'
            }
        },
        SystemNotifications: {
            title: {
                newBusiness: 'Новий бізнес',
                emailConfirmed: 'Підтвердження email',
                newClient: 'Новий клієнт',
                refilledPromoBalance: 'Поповнення рекламного рахунку',
                withdrawRequest: 'Виведення коштів',
                resetFee: 'Відсоток обнулено'
            },
            autocomplete: {
                type: 'Оберіть тип',
                status: 'Оберіть статус',
                read: 'Прочитано',
                unread: 'Не прочитано',
                newBusiness: 'Новий бізнес',
                emailConfirmed: 'Бізнес підтвердив email',
                refilledPromoBalance: 'Поповнення рекламного рахунку',
                newClient: 'Новий клієнт',
                withdrawRequest: 'Виведення коштів'
            },
            refilledPromoBalance: 'Поповнення рекламного рахунку на {currency} грн',
            newBusiness: 'Бізнесмен {content} став Вашим партнером!',
            emailConfirmed: 'Бізнесмен {content} підтвердив свою електронну пошту',
            newClient: 'Вітаємо! Клієнт {content} зареєструвався та став Вашим партнером!',
            withdrawRequest: '{content} зробив запит на виведення коштів!',
            noData: 'У Вас немає повідомлень',
            resetFee: '18.06. 2021г. закінчується бонусне нарахування дивідендів. Для подальшої співпраці Вам необхідно зв`язатися з адміністрацією.'
        },
        ConfirmAccount: {
            confirmedTitle: 'Акаунт успішно підтверджений',
            unconfirmedTitle: 'Посилання вже недійсне',
            subject: 'Підтвердження акаунта',
            text: 'Щоб підтвердити акаунт, перейдіть за посиланням'
        },
        SystemLogs: {
            actionType: 'Тип дії',
            email: 'Користувач',
            models: {
                ClientGroup: {
                    name: 'Назва',
                    type: 'Тип',
                    countOfOrders: 'К-сть замовлень',
                    values: 'К-сть замовлень',
                    subGroups: 'К-сть підгруп',
                    fromDate: 'Дата початку',
                    toDate: 'Дата завершення',
                    includeUnallocated: 'Включати нерозподілених',
                    onlyUnallocated: 'Тільки нерозподілені',
                    accountId: 'Кількість клієнтів',
                    brandId: 'ID бренда',
                    isDelivery: 'Група доставки',
                    brand: 'Бренд'
                },
                CashbackSystem: {
                    name: 'Назва',
                    clientGroup: 'Група клієнтів',
                    fromDate: 'Дата початку',
                    toDate: 'Дата завершення',
                    includeTelephony: 'Включати офлайн замовлення',
                    bonusReward: 'Нагорода',
                    textOnCreate: 'Текст при створенні',
                    textOnReward: 'Текст нагороди',
                    Step: {
                        name: 'Назва системи кешбеку',
                        percent: 'Відсоток кешбеку',
                        text: 'Текст при досягненні',
                        order: 'Кількість замовлень'
                    }
                },
                RASystem: {
                    name: 'Назва бонусної системи',
                    clientGroup: 'Група клієнтів',
                    fromDate: 'Дата початку',
                    toDate: 'Дата завершення',
                    bonusReward: 'Нагорода',
                    textOnCreate: 'Текст при створенні',
                    textOnReward: 'Текст нагороди',
                    Step: {
                        name: 'Назва бонусної системи',
                        bonusReward: 'Нагорода',
                        text: 'Текст при досягненні',
                        bonusCondition: 'Умова досягнення'
                    }
                },
                LTSystem: {
                    name: 'Назва бонусної системи',
                    clientGroup: 'Група клієнтів',
                    fromDate: 'Дата початку',
                    toDate: 'Дата завершення',
                    bonusReward: 'Нагорода',
                    textOnCreate: 'Текст при створенні',
                    textOnReward: 'Текст нагороди',
                    Step: {
                        name: 'Назва бонусної системи',
                        bonusReward: 'Нагорода',
                        text: 'Текст при досягненні',
                        bonusCondition: 'Умова досягнення'
                    }
                }
            },
            table: {
                date: 'Дата',
                user: 'Користувач',
                actionType: 'Тип дії',
                action: 'Дія'
            },
            types: {
                'login': 'Вхід в систему',
                'push-notification-send': 'Push-сповіщення',
                'refill-account-balance': 'Поповнення балансу акаунта',
                'create-code': 'Створення реферального коду',
                'create-account': 'Створення акаунту',
                'create-news': 'Створення публікації',
                'remove-news': 'Видалення публікації',
                'change-action-type-status': 'Зміна в налаштуваннях активності',
                'remove-code': 'Видалення реферального коду',
                'change-personal-data': 'Зміна персональних даних',
                'connect-google-account': 'Підключення google акаунту',
                'connect-facebook-account': 'Підключення facebook акаунту',
                'change-servers-fee': 'Зміна серверного відсотку',
                'set-to-zero-server-balance': 'Обнулення серверного балансу',
                'change-permission': 'Зміни в списку всіх дозволів',
                'change-admin-data': 'Редагування даних адміністратора',
                'change-role': 'Редагування ролі',
                'create-role': 'Створення ролі',
                'remove-role': 'Видалення ролі',
                'change-fee': 'Зміна відсотку',
                'create-client-group': 'Створення групи клієнтів',
                'edit-client-group': 'Редагування групи клієнтів',
                'remove-client-group': 'Видалення группи клієнтів',
                'create-cashback-system': 'Створення системи кешбеку',
                'change-cashback-system-activity': 'Активація системи кешбеку',
                'edit-cashback-system': 'Зміни в системі кешбеку',
                'complete-cashback-system': 'Завершення системи кешбеку',

                'create-cashback-step': 'Створення умови накопичення кешбеку',
                'edit-cashback-step': 'Редагування умови накопичення кешбеку',
                'remove-cashback-step': 'Видалення умови накопичення кешбеку',

                'create-ra-system': 'Створення бонусної системи за досягненням суми',
                'edit-ra-system': 'Редагування бонусної системи за досягненням суми',
                'change-ra-system-activity': 'Активація бонусної системи за досягненням суми',
                'complete-ra-system': 'Завершення бонусної системи за досягненням суми',

                'create-lt-system': 'Створення бонусної системи за кількістю замовлень',
                'edit-lt-system': 'Редагування бонусної системи за кількістю замовлень',
                'change-lt-system-activity': 'Активація бонусної системи за кількістю замовлень',
                'complete-lt-system': 'Завершення бонусної системи за кількістю замовлень',

                'create-ra-step': 'Створення умови накопичення бонусу за досягненням суми',
                'edit-ra-step': 'Редагування умови накопичення бонусу за досягненням суми',
                'remove-ra-step': 'Видалення умови накопичення бонусу за досягненням суми',

                'create-lt-step': 'Створення умови накопичення бонусу за кількістю замовлень',
                'edit-lt-step': 'Редагування умови накопичення бонусу за кількістю замовлень',
                'remove-lt-step': 'Видалення умови накопичення бонусу за кількістю замовлень',

                'funds-purchase': 'Покупка рекламних коштів',
                'funds-charge': 'Поповнення рекламного рахунку',
                'lock-account': 'Блокування акаунту',
                'change-account-status': 'Зміна статусу акаунту',
                'change-account-price': 'Зміна ціни акаунту'
            },
            messages: {
                'login': 'Сесія була створена з параметром "Запам\'ятати мене" зі значенням {0}',
                'refill-account-balance': 'Баланс користувача {0} було поповнено на {1} грн.',
                'create-code': 'Користувач {0} створив реферальний код {1} з назвою "{2}"',
                'remove-code': 'Користувач {0} видалив реферальний код {1} з назвою "{2}"',
                'create-account': 'Створено новий акаунт {0} з роллю "{1}"',
                'lock-account': 'Акаунт {0} було {1}',
                'change-action-type-status': 'Логування дії "{0}" було {1}',
                'change-permission': ' Дозвіл типу "{0}" було {1}',
                'create-news': 'Користувач {0} створив нову публікацію з заголовком "{1}"',
                'remove-news': 'Користувач {0} видалив публікацію з заголовком "{1}"',
                'connect-google-account': 'Користувач {0} підключив google-акаунт',
                'connect-facebook-account': 'Користувач {0} підключив facebook-акаунт',
                'push-notification-send': 'Користувач {0} відправив push-сповіщення {1} клієнтам: {2} успішно, {3} не успішно',
                'change-servers-fee': 'Змінено відсоток для сервера {0} - з {1} на {2}',
                'set-to-zero-server-balance': 'Обнулено баланс сервера - {0}',
                'create-role': 'Адміністратор {0} створив роль "{1}" з дозволами: {2}.',
                'remove-role': 'Роль "{0}" було видалено.',
                'change-fee': 'Адміністратор {0} змінив відсоток для акаунту {1} з {2}% на {3}%',
                'create-client-group': 'Створено групу клієнтів "{0}" з параметрами:\n{1}',
                'remove-client-group': 'Групу клієнтів "{0}" було видалено',
                'create-cashback-system': 'Створено систему кешбеку з параметрами:\n{0}',
                'change-cashback-system-activity': 'Система кешбеку "{0}" -> {1}',
                'complete-cashback-system': 'Систему кешбеку "{0}" було завершено',

                'create-ra-system': 'Створено систему кешбеку з параметрами:\n{0}',
                'change-ra-system-activity': 'Система кешбеку "{0}" -> {1}',
                'complete-ra-system': 'Систему кешбеку "{0}" було завершено',

                'create-lt-system': 'Створено систему кешбеку з параметрами:\n{0}',
                'change-lt-system-activity': 'Система кешбеку "{0}" -> {1}',
                'complete-lt-system': 'Систему кешбеку "{0}" було завершено',

                'change-personal-data': {
                    user: ' Користувач {0}',
                    add: 'заповнив поле "{0}" значенням "{1}" у свому акаунті',
                    change: 'змінив значення поля "{0}" з "{1}" на "{2}"',
                    readTerms: 'ознайомився з умовами використання'
                },
                'change-admin-data': {
                    user: 'Користувач {0} редагував акаунт {1}',
                    add: 'заповнив поле "{0}" значенням "{1}"',
                    change: 'змінив значення поля "{0}" з "{1}" на "{2}"'
                },
                'change-role': {
                    user: ' Користувач {0} змінив роль {1}',
                    name: 'назву з {0} на {1}',
                    permissions: 'список дозволів з [{0}] на [{1}]',
                    categories: 'список категорій звітів з [{0}] на [{1}]',
                    activity: 'роль було',
                    enabled: 'активовано',
                    disabled: 'деактивовано'
                },
                'edit-client-group': {
                    result: 'Змінено групу клієнтів "{0}"',
                    change: 'поле "{0}" з {1} на {2}',
                    linkClients: 'включено клієнтів користувача номер {0}',
                    unlinkClients: 'відключено клієнтів користувача номер {0}'
                },
                'edit-cashback-system': {
                    result: 'Змінено систему кешбеку "{0}"',
                    change: 'поле "{0}" з {1} на {2}'
                },
                'edit-ra-system': {
                    result: 'Змінено бонусну систему по досягненню суми "{0}"',
                    change: 'поле "{0}" з {1} на {2}'
                },
                'edit-lt-system': {
                    result: 'Змінено бонусну систему по кiлькостi замовлень "{0}"',
                    change: 'поле "{0}" з {1} на {2}'
                },
                'funds-purchase': 'Куплено рекламних коштів: {0} по коефіцієнту {1}',
                'funds-charge': {
                    admin: {
                        all: {
                            leader: 'Рекламний рахунок всіх лідерів (к-сть - {0}) було поповнено на {1} ₴',
                            business: 'Рекламний рахунок всіх бізнесів (к-сть - {0}) було поповнено на {1} ₴',
                            client: 'Рекламний рахунок всіх клієнтів (к-сть - {0}) було поповнено на {1} ₴'
                        },
                        some: {
                            leader: 'Рекламний рахунок лідера (id: {0}) було поповнено на {1} ₴',
                            business: 'Рекламний рахунок бізнеса (id: {0}) було поповнено на {1} ₴'
                        },
                        amount: {
                            leader: 'Рекламний рахунок лідерів, які мають більше {0} бізнесів (к-сть - {1}), було поповнено на {2} ₴',
                            business: 'Рекламний рахунок бізнесів, які мають більше {0} клієнтів (к-сть - {1}), було поповнено на {2} ₴'
                        },
                        date: {
                            leader: 'Рекламний рахунок лідерів, які зареєструвались {0} {1} (к-сть - {2}), було поповнено на {3} ₴',
                            business: 'Рекламний рахунок бізнесів, які зареєструвались {0} {1} (к-сть - {2}), було поповнено на {3} ₴'
                        }
                    },
                    leader: {
                        all: {
                            business: 'Поповнив рекламний рахунок всіх своїх бізнесів (к-сть - {0}) на {1} ₴',
                            client: 'Поповнив рекламний рахунок всіх своїх клієнтів (к-сть - {0}) на {1} ₴'
                        },
                        some: {
                            business: 'Поповнив рекламний рахунок свого бізнеса (id: {0}) на {1} ₴'
                        },
                        amount: {
                            business: 'Поповнив рекламний рахунок своїх бізнесів, які мають більше {0} клієнтів (к-сть - {1}), на {2} ₴'
                        },
                        date: {
                            business: 'Поповнив рекламний рахунок своїх бізнесів, які зареєструвались {0} {1} (к-сть - {2}), на {3} ₴'
                        }
                    },
                    business: {
                        all: {
                            client: 'Поповнив рекламний рахунок всіх своїх клієнтів (к-сть - {0}) на {1} ₴'
                        }
                    },
                    before: 'до',
                    after: 'після'
                },
                'change-account-status': 'Статус акаунту "{0}" було змінено з "{1}" на "{2}"',
                'change-account-price': 'Поле "{0}" акаунту "{1}" було змінено з "{2}" на "{3}"',
                amountToPay: 'Вартість облікового запису',
                amountPaid: 'Виплачена сума',
                enabled: 'увімкнено',
                disabled: 'вимкнено',
                locked: 'заблоковано',
                unlocked: 'розблоковано'
            },
            settings: {
                name: 'Тип логування',
                activation: 'Активація'
            }
        },
        Reset: {
            title: 'Змініть свій пароль',
            labels: {
                newPassword: 'Новий пароль',
                confirmPassword: 'Повторіть пароль'
            }
        },
        PromotionalAccount: {
            before: 'До',
            after: 'Після',
            promotionalAccountReplenishment: 'Поповнення ручного рекламного рахунку',
            purchaseRate: 'Нинішній курс купівлі',
            willBeBought: 'Буде куплено',
            wannaSpend: 'Хочу витратити',
            additionalSettings: 'Додаткові налаштування',
            numberOfUsers: 'Кількість користувачів для нарахування',
            numberOfFunds: 'Кількість коштів для нарахування',
            numberOfBusinesses: 'Кількість бізнесів',
            numberOfClients: 'Кількість клієнтів',
            promotionalAccountBalance: 'Ваш баланс рекламного рахунку становить',
            advertisingBalance: 'Рекламний баланс',
            mainBalance: 'Основний баланс',
            leader: {
                all: 'Всім лідерам',
                some: 'Конкретному лідеру',
                amount: 'Кількість бізнесів більше N',
                date: 'Реєстрація до/після'
            },
            business: {
                all: 'Всім бізнесам',
                some: 'Конкретному бізнесу',
                amount: 'Кількість клієнтів більше N',
                date: 'Реєстрація до/після'
            },
            client: {
                all: 'Всім клієнтам',
                some: 'Клієнтам бізнеса'
            }
        },
        Groups: {
            table: {
                id: 'Номер групи',
                establishment: 'Заклад',
                name: 'Назва',
                selection: 'Вибір',
                type: 'Тип',
                values: 'Кількість поїздок',
                includeUnallocated: 'Включати нерозподілених',
                onlyUnallocated: 'Тільки нерозподілені',
                fromDate: 'З дати',
                toDate: 'По дату',
                accountId: 'Аккаунт в системі',
                clients: 'К-сть клієнтів',
                createdAt: 'Створено',
                used: 'Використовується',
                phones: 'Список телефонів',
                actions: 'Дії',
                brand: 'Бренд',
                scope: 'Ціль',
                bonusSystem: 'Тип бонусів',
                autoAdd: 'Автододавання',

                bonusSystems: {
                    sum: 'Сума затрат',
                    count: 'Кількість замовлень',
                    cashbackPercent: '% кешбека'
                }
            },
            relocationOfClients: 'Перерозподіл користувачів',
            someClientsAreAlreadyInGroup: 'Деякі номери вже знаходяться в іншій групі. Зверніть увагу, що при створенні нової вони будуть переведені до неї.',
            validation: {
                success: 'Успіх',
                validationError: 'Помилка валідації',
                alreadyInGroup: 'Вже у групі',
                notFound: 'Не знайдено'
            },
            allEstablishments: 'Усі заклади',
            all: 'Усі',
            editor: {
                create: 'Створення групи',
                edit: 'Редагування групи',
                startTyping: 'Почніть вводити для пошуку',
                subGroups: 'Кількість підгруп',
                clientsCount: 'Кількість клієнтів',
                willBeSentToAllClients: 'Включає усіх клієнтів',
                autoAddNewClients: 'Автоматично додавати нових клієнтів',
                removeDialog: {
                    title: 'Видалити групу?',
                    desc: 'Дана група буде повністю видалена з системи'
                }
            },
            selections: {
                custom: 'Ручний',
                condition: 'За умовою',
                taxi: 'Таксі',
                delivery: 'Доставка'
            },
            types: {
                equal: 'Дорівнює',
                less: 'Менше',
                more: 'Більше',
                range: 'Діапазон'
            },
            filters: {
                valuesFrom: 'Кількість поїздок від',
                valuesTo: 'Кількість поїздок до'
            },
            bonusSystems: {
                sum: 'По сумі затрачених коштів',
                count: 'По кількості замовлень',
                cashbackPercent: 'Відсоток кешбека (за замовчуванням)'
            },
            cashbackSystem: 'Система кешбека',
            countOfClients: 'Кількість клієнтів',
            withGroup: 'В групах',
            withoutGroup: 'Не в групах',
            unallocated: 'Нерозподілені',
            manualMode: 'Ручний режим',
            isDelivery: 'Доставка'
        },
        Cashback: {
            table: {
                id: 'Номер',
                name: 'Назва',
                groupId: 'Група',
                fromDate: 'З дати',
                toDate: 'По дату',
                enabled: 'Включена',
                wasStartedUp: 'Активна',
                progress: 'Прогрес',
                clients: 'Кількість клієнтів',
                totalOrderCount: 'Кількість поїздок',
                totalCommission: 'Комісія',
                totalCashback: 'Кешбек',
                includeTelephony: 'Включати офлайн замовлення',
                createdAt: 'Створено',
                deletedAt: 'Завершено',
                actions: 'Дії',
                bonusSystem: 'Тип бонусів',
                groupType: 'Тип групи',
                brand: 'Бренд'
            },
            useAsTemplate: 'Використання системи кешбека як шаблону',
            filters: {
                countClientsFrom: 'Кількість клієнтів від',
                countClientsTo: 'Кількість клієнтів до',
                totalOrderFrom: 'Кількість поїздок від',
                totalOrderTo: 'Кількість поїздок до'
            }
        },
        CashbackEditor: {
            mainParams: 'Основні параметри',
            sequencesTable: 'Послідовна таблиця нарахувань',
            table: {
                order: 'Номер поїздки',
                percent: 'Процент',
                text: 'Текст пуш-повідомлення',
                actions: 'Дії',
                amount: 'Сума повернення',
                count: 'Кількість замовлень',
                sum: 'Витрачена сума'
            }
        },
        Moderation: {
            statuses: {
                success: 'Перевірено',
                check: 'Модерація',
                filling: 'Заповнення',
                cancelled: 'Помилка'
            },
            table: {
                type: 'Тип',
                firstName: 'Ім\'я',
                lastName: 'Прізвище',
                email: 'Електронна адреса',
                phoneNumber: 'Номер телефону',
                cardNumber: 'Номер картки',
                taxId: 'Ідентифікаційний код',
                passportNumber: 'Номер паспорта',
                status: 'Статус',
                createdAt: 'Створено'
            }
        },
        404: {
            title: 'Упсс!',
            text: 'Схоже, ви перебуваєте на незвіданій території. Ми ще не знаємо про цю сторінку. На щастя, ми знаємо зворотній шлях.',
            return: 'Назад'
        }
    },
    types: {
        admin: 'Адмін',
        leader: 'Лідер',
        business: 'Бізнес',
        client: 'Клієнт'
    },
    messages: {
        error: {
            unknown: 'Невідома помилка',
            invalidToken: 'Не вірний токен пристрою',
            emailAlreadyExist: 'Електронна адреса вже існує',
            accountAlreadyExist: 'Акаунт вже існує',
            passwordDoesntMatch: 'Паролі не співпадають',
            accountNotFound: 'Акаунт не знайдено',
            isPhoneExist: 'Телефон вже зареєстрований у системі',
            isAccountExist: 'Обліковий запис вже зареєстрований в системі',
            isCodeValid: 'Код підтвердження некоректний',
            incorrectEmailOrPassword: 'Невірна електронна адреса чи пароль',
            tokenInvalid: 'Токен недійсний',
            notAllAccountInformation: 'Для виведення коштів заповніть особисту інформацію в налаштуваннях Вашого акаунта',
            invalidSum: 'Сума не коректна',
            newsNotFound: 'Новина не існує',
            invalidAmount: 'Сума некоректна',
            emailNotConfirmed: 'Електронна адреса не підтверджена',
            phoneNotFound: 'Номер телефону не існує',
            countUsers: 'Користувачів з такими параметрами не знайдено',
            removed: 'Запис успішно видалено',
            accessDenied: 'Доступ заборонено для вашої ролі',
            roleNotFound: 'Роль не знайдено',
            reportNotFound: 'Звіт не знайдено',
            reportGenerateError: 'Помилка під час виконання SQL-запиту',
            roleIdIsRequired: 'Неможливо створити адміністратора без ролі',
            cannotDisableOwnRole: 'Ви не можете вимкнути роль, до якої відноситесь',
            findAccountWithThisRole: 'Неможливо видалити роль, поки до неї відноситься хоча б один акаунт',
            reportFoundWithThisCategory: 'Ця категорія містить звіти',
            incorrectEmail: 'Невірна електронна адреса',
            duplicateName: 'Це ім\'я уже використовується',
            accountLocked: 'Ваш акаунт було заблоковано. Зверніться до адміністратора',
            lessThanMin: 'Менше мінімального значення',
            moreThanLimit: 'Перевищено встановлений ліміт',
            limits: {
                lessThanExistAccounts: 'Ліміт акаунтів не може бути меншим, ніж к-сть запрошених бізнесів.',
                lessThanExistClients: 'База клієнтів не може бути меншою, ніж к-сть запрошених клієнтів.',
                cantBeLimited: 'Аккаунт не може бути обмежений'
            },
            greaterThanLeaderFee: 'Ви не можете віддати більше, ніж маєте',
            telephonyDisabled: 'Офлайн замовлення не включено',
            accountAmount: {
                lessThanMin: 'Менше мінімального значення',
                moreThanMax: 'Більше максимального значення',
                lessThanPaid: 'Менше, ніж вже оплачено',
                moreThanNeedPay: 'Більше, ніж потрібно оплатити'
            },
            autologout: 'Ви були відсутні занадто довго. Будь ласка, перезайдіть'
        },
        success: {
            resend: 'На ваш телефон надіслано SMS з кодом підтвердження',
            login: 'Успішний вхід',
            successMessage: 'Повідомлення успішно відправлені.',
            deletedArticle: 'Новина була видалена',
            savedArticle: 'Новина збережена',
            createdArticle: 'Новина створена',
            emailAlreadyExist: 'Електронна адреса вже існує',
            register: 'Акаунт успішно створений. Будь ласка, перейдіть на пошту і підтвердіть реєстрацію!',
            registerAdmin: 'Акаунт успішно створений.',
            copy: 'Cкопійовано у буфер обміну',
            accountRegister: 'Акаунт успішно створений',
            accountUpdated: 'Акаунт успішно оновлено',
            passwordChanged: 'Пароль успішно змінено',
            feedCreated: 'Новину успішно опубліковано',
            feedUpdated: 'Новину успішно оновлено',
            feedDeleted: 'Новину успішно видалено',
            linkShared: 'Ви успішно поділились посиланням',
            refillPromoBalance: 'Рекламний баланс успішно поповнений',
            refillBalance: 'Баланс успішно поповнений',
            confirmBusiness: 'Акаунт успішно підтверджений',
            success: 'Операція успішно виконана',
            updated: 'Оновлено',
            role: {
                updated: 'Роль успішно оновлено',
                created: 'Нову роль успішно створено',
                removed: 'Роль успішно видалено'
            },
            report: {
                updated: 'Звіт успішно оновлено',
                created: 'Новий звіт успішно створено',
                removed: 'Звіт успішно видалено'
            },
            category: {
                updated: 'Категорію успішно оновлено',
                created: 'Нову категорію успішно створено',
                removed: 'Катагорію успішно видалено'
            }
        }
    },
    authorManagement: 'Обліковий запис перебуває під авторським управлінням до {0}',
    buttons: {
        create: 'Створити',
        cancel: 'Відмінити',
        delete: 'Видалити',
        save: 'Зберегти',
        next: 'Далі',
        resend: 'Не отримано смс',
        ok: 'ОК',
        changePhoneNumber: 'Змінити номер телефону',
        search: 'Пошук',
        reset: 'Скинути',
        send: 'Відправити',
        checkPhones: 'Перевірити телефони',
        change: 'Змінити',
        apply: 'Застосувати',
        update: 'Оновити',
        download: 'Завантажити',
        upload: 'Завантажити',
        withdraw: 'Вивести',
        generate: 'Сформувати',
        excel: 'Завантажити таблицю',
        refill: 'Поповнити',
        charge: 'Нарахувати',
        calculate: 'Розрахувати',
        buy: 'Купити',
        hide: 'Приховати',
        enabled: 'Активувати',
        disabled: 'Дизактивувати',
        complete: 'Завершити',
        use: 'Використовувати',
        check: 'Перевірити',
        resetFee: 'Скинути відсоток',
        excludeResetFee: 'Враховувати при обнуленні'
    },
    notifications: {
        delete: 'Ви впевнені, що хочете видалити запис?',
        deletePayout: 'Ви впевнені, що хочете скасувати заявку на виплату?'
    },
    table: {
        load: 'Дані завантажуються',
        noData: 'Дані відсутні'
    },
    phone: {
        countrySelectorLabel: 'Код країни',
        phoneNumberLabel: 'Номер телефона',
        example: 'Наприклад:'
    },
    date: {
        fromDate: 'Початкова дата',
        toDate: 'Кінцева дата',
        date: 'Дата',
        birthday: 'День народження'
    },
    select: {
        searchBy: 'Пошук по',
        selectLeader: 'Виберіть лідера',
        selectBusiness: 'Виберіть бізнесмена',
        selectCode: 'Виберіть код',
        noData: 'Дані відсутні',
        selectType: 'Тип'
    },
    links: {
        backToPayments: 'Назад до платежів'
    },
    markdown: {
        link: 'посилання',
        text: 'текст',
        preview: 'Переглянути'
    },
    noData: {
        empty: 'Список порожній'
    },
    currencies: {
        hrn: 'грн'
    },
    true: 'Так',
    false: 'Ні',
    noDataText: 'Дані відсутні',
    others: '{0} інших',
    dataIterator: {
        noResultsText: 'Немає результату'
    },
    editDialog: {
        saveText: 'Натисніть Enter щоб зберегти'
    },
    validateData: {
        cancelled: 'Дані не пройшли перевірку. Заповніть особисті дані знову і оновіть обліковий запис.',
        check: 'Дані перевіряються.',
        filling: 'Заповніть всі персональні дані, щоб продовжити працювати в системі. У разі зазначення некоректних даних, Ваш обліковий запис може бути заблокований.'
    }
}
